/** Width (in space steps) of the price history popper, in the sourcing table and the preview. */
export const PRICE_CHANGE_DETAIL_WIDTH = 133;
